import { SendOutlined } from "@ant-design/icons";
import { Space, Form, Row, Button, Col, Input } from "antd";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Spin } from "antd";
import { useAxiosPrivate } from "../../../hooks/useAxiosPrivate";
import { useChatStore } from "../chat-app-store/chat-store.js";
import { useSessionStore } from "../../../store/session-store.js";
import { ChatCard } from "../chat-card/ChatCard.jsx";
import { GridLayout } from "../grid-layout/GridLayout.jsx";
import "./Chat.css";

function Chat({ appId }) {
  const [message, setMessage] = useState("");
  const axiosPrivate = useAxiosPrivate();
  const { sessionDetails } = useSessionStore();
  const [isSending, setIsSending] = useState(false);

  const {
    setDefaultChatDetails,
    updateChatHistory,
    chatTranscript,
    currentContext,
    setCurrentContext,
    updateChatTranscript,
    isQuestionAsked,
    setIsQuestionAsked,
  } = useChatStore();

  useEffect(() => {
    return () => {
      setDefaultChatDetails();
    };
  }, []);

  useEffect(() => {
    if (isQuestionAsked) {
      setIsSending(true);
      setIsQuestionAsked(false);
    } else {
      setIsSending(false);
    }
  }, [chatTranscript.length]);

  const sendOrUpdateMessage = async (message, context, isFirstChat) => {
    const messageBody = {
      message: message,
      chat_history_id: context?.id,
      session_id: context?.session_id,
    };
    const header = {
      "X-CSRFToken": sessionDetails?.csrfToken,
      "Content-Type": "application/json",
    };
    const messageRequestOptions = {
      method: "POST",
      url: `/api/v1/unstract/${sessionDetails?.orgId}/chat/`,
      headers: header,
      data: messageBody,
    };
    const resTranscript = await axiosPrivate(messageRequestOptions);
    if (isFirstChat) {
      updateChatHistory({
        id: context?.id,
        label: message.slice(0, 15),
        session_id: resTranscript?.data?.session_id,
      });
    }

    setIsQuestionAsked(false);
    updateChatTranscript({
      id: resTranscript.data.id,
      role: resTranscript.data.role,
      message: resTranscript.data.message,
    });
    context["session_id"] = resTranscript.data.session_id;
    setCurrentContext(context);
  };

  const sendMessage = async () => {
    setIsQuestionAsked(true);
    updateChatTranscript({
      role: "USER",
      message: message,
    });

    const header = {
      "X-CSRFToken": sessionDetails?.csrfToken,
      "Content-Type": "application/json",
    };

    const body = {
      label: message,
      app_id: appId,
    };

    const requestOptions = {
      method: "POST",
      url: `/api/v1/unstract/${sessionDetails?.orgId}/chat_history/`,
      headers: header,
      data: body,
    };
    if (!currentContext.id) {
      const res = await axiosPrivate(requestOptions);
      setCurrentContext(res.data);
      sendOrUpdateMessage(message, res?.data, true);
    } else {
      sendOrUpdateMessage(message, currentContext, false);
    }

    setMessage("");
  };

  const handleEnterSubmit = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      sendMessage(message);
    }
  };

  return (
    <GridLayout>
      <Row className="chat-section-row" justify="center">
        <Col span={16}>
          <div className="chat-interaction-section">
            <div className="chat-messages">
              {chatTranscript.length === 0 ? (
                <div className="chat-placeholder">
                  <h2>Unstract Chat</h2>
                  <p>Placeholder for unstract multi-doc chat</p>
                </div>
              ) : (
                chatTranscript.map((item, index) => (
                  <ChatCard
                    key={item.id}
                    content={item.message}
                    chatTitle={item.role === "USER" ? "" : "Answer"}
                  />
                ))
              )}
            </div>
            <Form
              layout="vertical"
              onFinish={sendMessage}
              className="chat-form"
            >
              <Form.Item name="message">
                <Input.TextArea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  onPressEnter={handleEnterSubmit}
                  placeholder="Enter your prompt here"
                  className="chat-input"
                  autoSize={{ minRows: 2, maxRows: 8 }}
                  disabled={isSending}
                />
                <Space className="chat-btn">
                  {isSending ? (
                    <Spin />
                  ) : (
                    <Button
                      type="primary"
                      htmlType="submit"
                      icon={<SendOutlined />}
                    ></Button>
                  )}
                </Space>
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
    </GridLayout>
  );
}
Chat.propTypes = {
  appId: PropTypes.string.isRequired,
};
export { Chat };
